export default "__VITE_ASSET__DXs_3Bwl__"